module.exports = __webpack_public_path__ + "static/img/activity2.6702824.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/activity/activity2.png
// module id = +YH1
// module chunks = 1